import { useEffect, useState } from "react";
import { useRouter } from "../../../../../hooks/router";
import { get_related_movies } from "../../../../../server/requests";

import './SimilarContent.scss'

import icon_back from "../../../../SubUsers/images/back-button.png";

import RowList from "../../../../Row_List/RowList";
import Loading from "../../../../Loading/Loading";
import AlertMessage from "../../../../AlertMessage/ErrorMessage";

export default function SimilarContent({ btn_show_similar_content, stop_propogation,isGuest }) {
    const router = useRouter()

    const [relatedMovies, setRelatedMovies] = useState([])
    const [showLoading, setShowLoading] = useState(true)
    const [alertMessage, setAlertMessage] = useState({
        type: '',
        show: false,
        text: ''
    })

    useEffect(() => {
        if (router.query.id) {
            setShowLoading(true)
            get_related_movies({ id: router.query.id }, data => {
                setRelatedMovies([...data[0].content])
                if (!data[0].content.length) {
                    show_error_message()
                }
                setTimeout(() => {
                    setShowLoading(false)
                }, 500)
            }, err => console.log(err))
        }
    }, [router.query.id])

    const show_error_message = () => {
        setTimeout(() => {
            setAlertMessage({
                type: 'error',
                show: true,
                text: 'Similar content is empty'
            })
            hide_error_message()
        }, 100);
    }

    const hide_error_message = () => {
        setTimeout(() => {
            setAlertMessage({
                type: '',
                show: false,
                text: ''
            })
            btn_show_similar_content()
        }, 1000)
    }

    return (
        <>

            <AlertMessage type={alertMessage.type} show={alertMessage.show} text={alertMessage.text} />
            <div className="main_similar_content" onClick={btn_show_similar_content}>
                <img src={icon_back} className="close_field_player_movie" onClick={btn_show_similar_content} />
                {showLoading ?
                    <Loading />
                    : null}

                <div className="parent_similar_content" style={!showLoading ? { opacity: '1' } : null} onClick={stop_propogation}>
                    {relatedMovies.length ?
                        <RowList
                            title={'Similar Content'}
                            type={'movie'}
                            row={0}
                            array={relatedMovies}
                            isGuest={isGuest}

                        />
                        : null}
                </div>
            </div>

        </>
    )
}